import LogoWithoutEndorsment from 'img/portal-menu/cloud-touch-logo.svg';
import LogoWithEndorsment from 'img/portal-menu/cloud-vk-logo.svg';
import b2bLogo from 'img/portal-menu/portal-menu__logo_vk-workdisk.svg?url';

export const getLogoSrc = ({ withEndorsment, logoSrc, isBizUser }): string => {
    if (logoSrc) {
        return logoSrc;
    }

    if (isBizUser) {
        return b2bLogo;
    }

    return withEndorsment ? LogoWithEndorsment : LogoWithoutEndorsment;
};

export const getAlt = (isBizUser?: boolean): string => {
    return isBizUser ? 'VK WorkDisk' : 'Облако Mail.ru';
};
